import React from "react";
import i18next from "i18next";
import {
  Button,
  NumericInput
} from "@blueprintjs/core";
import {
  DateInput3
} from "@blueprintjs/datetime2";

export class EditableNumber extends React.Component {
  constructor(props) {
    super();
    this.state = {
      edit: false,
      inputValue: undefined
    };
  }
  render() {
    return (
      <span>
        {this.state.edit ?
          <span>
            <NumericInput
              style={{ maxWidth: 80 }} fill={false}
              min={this.props.min} max={this.props.max} placeholder={this.props.value}
              onValueChange={(valueAsNumber) => this.setState({ inputValue: valueAsNumber })}
            /> {this.props.unit} {this.props.value > 1 ? "s" : ""})
            <Button icon="tick" intent="success" onClick={() => this.setState({ edit: false }, () => this.props.handleValue(this.state.inputValue))}
              disabled={this.state.inputValue === undefined || isNaN(this.state.inputValue) || (this.props.min !== undefined && this.state.inputValue < this.props.min) || (this.props.max !== undefined && this.state.inputValue > this.props.max)}
            />
            <Button icon="cross" intent="danger" onClick={() => this.setState({ edit: false })} />
          </span>
          :
          <span>{this.props.value} {this.props.unit}{this.props.value > 1 ? "s" : ""} <Button icon="edit" onClick={() => this.setState({ edit: !this.state.edit })} /></span>}
      </span>
    );
  }
}

export class EditableDate extends React.Component {
  constructor(props) {
    super();
    this.state = {
      edit: false,
      inputValue: undefined
    };
  }
  render() {
    return (
      <span>
        {this.state.edit ?
          <span>
            <DateInput3
              timePrecision="minute"
              highlightCurrentDay={true}
              minDate={new Date(this.props.min)} maxDate={new Date(this.props.max)} 
              placeholder={this.props.value.toLocaleString(i18next.language)}
              onChange={(selectedDate) => this.setState({ inputValue: selectedDate })}
              locale={i18next.language}
              formatDate={(date) => date.toLocaleString(i18next.language)}
              showTimezoneSelect={false}
            />
            <Button icon="tick" intent="success" onClick={() => this.setState({ edit: false }, () => this.props.handleValue(this.state.inputValue))}
              disabled={this.state.inputValue === undefined}
            />
            <Button icon="cross" intent="danger" onClick={() => this.setState({ edit: false })} />
          </span>
          :
          <span>{new Date(this.props.value).toLocaleString(i18next.language)} <Button icon="edit" onClick={() => this.setState({ edit: !this.state.edit })} /></span>}
      </span>
    );
  }
}
